import React from "react";

const BOOKING_STATUS_CONFIG = {
  Confirmed: { color: "text-emerald-600", bg: "bg-emerald-100" },
  Pending: { color: "text-amber-600", bg: "bg-amber-100" },
  Completed: { color: "text-green-600", bg: "bg-green-100" },
  Cancelled: { color: "text-red-600", bg: "bg-red-100" },
  Declined: { color: "text-rose-600", bg: "bg-rose-100" },
  Started: { color: "text-violet-600", bg: "bg-violet-100" },
  Headed: { color: "text-indigo-600", bg: "bg-indigo-100" },
  Reached: { color: "text-sky-600", bg: "bg-sky-100" },
  Scanned: { color: "text-teal-600", bg: "bg-teal-100" },
  OnHold: { color: "text-orange-600", bg: "bg-orange-100" },
};

const VERIFICATION_STATUS_CONFIG = {
  VERIFIED: { color: "text-green-700", bg: "bg-green-100" },
  PAYMENT_VERIFICATION_PENDING: {
    color: "text-amber-700",
    bg: "bg-amber-100",
  },
  SCAN_VERIFICATION_PENDING: {
    color: "text-blue-700",
    bg: "bg-blue-100",
  },
  Pending: { color: "text-red-700", bg: "bg-red-100" },
};

const BookingsSummaryCard = ({
  totalBookings = 0,
  statusCounts = {},
  verificationStatusCounts = {},
  completedUnverifiedCount,
  onStatusClick,
  onVerificationStatusClick,
  onCompletedUnverifiedClick,
}) => {
  return (
    <div className="w-[95%] xl:w-1/3 bg-[#FBB033] rounded-3xl p-7 flex flex-col gap-6 shadow-lg">
      
      {/* Header */}
      <div className="flex items-center gap-4">
        <img src="/Assets/Security.png" alt="Bookings" className="w-11 h-11" />
        <div>
          <p className="text-[#39354E] text-sm font-medium">
            Total Bookings
          </p>
          <p className="text-[#39354E] text-2xl font-bold">
            {totalBookings}
          </p>
        </div>
      </div>

      <div className="w-full h-[1px] bg-[#ECF1FF]" />

      {/* Booking Status */}
      <div className="grid grid-cols-2 gap-3">
        {Object.entries(BOOKING_STATUS_CONFIG).map(
          ([status, styles]) =>
            statusCounts[status] !== undefined && (
              <div
                key={status}
                onClick={() =>
                  onStatusClick?.(status)
                }
                className={`cursor-pointer rounded-xl px-3 py-2 flex justify-between items-center ${styles.bg} hover:scale-105 transition`}
              >
                <span className={`text-xs font-semibold ${styles.color}`}>
                  {status}
                </span>
                <span className="text-[#39354E] font-bold text-sm">
                  {statusCounts[status]}
                </span>
              </div>
            )
        )}
      </div>

      <div className="w-full h-[1px] bg-[#ECF1FF]" />

      {/* Verification Status */}
      <div className="flex flex-col gap-2">
        <p className="text-[#39354E] text-sm font-semibold">
          Verification Status
        </p>

        {Object.entries(VERIFICATION_STATUS_CONFIG).map(
          ([status, styles]) =>
            verificationStatusCounts[status] !== undefined && (
              <div
                key={status}
                onClick={() =>
                  onVerificationStatusClick?.(status)
                }
                className={`cursor-pointer rounded-xl px-4 py-2 flex justify-between items-center ${styles.bg} hover:scale-105 transition`}
              >
                <span className={`text-xs font-semibold ${styles.color}`}>
                  {status.replaceAll("_", " ")}
                </span>
                <span className="text-[#39354E] font-bold text-sm">
                  {verificationStatusCounts[status]}
                </span>
              </div>
            )
        )}

        {completedUnverifiedCount !== undefined && (
          <div
            onClick={() => onCompletedUnverifiedClick?.()}
            className="cursor-pointer rounded-xl px-4 py-2 flex justify-between items-center bg-red-100 border border-red-300 hover:scale-105 transition"
          >
            <span className="text-xs font-semibold text-red-700">
              COMPLETED BUT UNVERIFIED
            </span>
            <span className="text-[#39354E] font-bold text-sm">
              {completedUnverifiedCount}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default BookingsSummaryCard;